// OpenAI Whisper supported languages relevant to South Africa
export const WHISPER_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'af', name: 'Afrikaans', flag: '🇿🇦' },
  { code: 'zu', name: 'Zulu (isiZulu)', flag: '🇿🇦' },
  { code: 'xh', name: 'Xhosa (isiXhosa)', flag: '🇿🇦' },
  { code: 'st', name: 'Sotho (Sesotho)', flag: '🇿🇦' },
  { code: 'tn', name: 'Tswana (Setswana)', flag: '🇿🇦' },
  { code: 'nso', name: 'Pedi (Sepedi)', flag: '🇿🇦' },
  { code: 've', name: 'Venda (Tshivenda)', flag: '🇿🇦' },
  { code: 'ts', name: 'Tsonga (Xitsonga)', flag: '🇿🇦' },
  { code: 'ss', name: 'Swati (siSwati)', flag: '🇿🇦' },
  { code: 'nr', name: 'Ndebele (isiNdebele)', flag: '🇿🇦' },
  // Additional common languages in South Africa
  { code: 'hi', name: 'Hindi', flag: '🇮🇳' },
  { code: 'ur', name: 'Urdu', flag: '🇵🇰' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹' },
  { code: 'fr', name: 'French', flag: '🇫🇷' },
  { code: 'de', name: 'German', flag: '🇩🇪' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸' },
  { code: 'it', name: 'Italian', flag: '🇮🇹' },
  { code: 'nl', name: 'Dutch', flag: '🇳🇱' },
  { code: 'ar', name: 'Arabic', flag: '🇸🇦' },
  { code: 'zh', name: 'Chinese', flag: '🇨🇳' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵' },
  { code: 'ko', name: 'Korean', flag: '🇰🇷' },
  { code: 'ru', name: 'Russian', flag: '🇷🇺' }
]

// Default language
export const DEFAULT_LANGUAGE = 'en'

// Get language name by code
export const getLanguageName = (code) => {
  const language = WHISPER_LANGUAGES.find((lang) => lang.code === code)
  return language ? language.name : 'English'
}

// Get language options for Select component
export const getLanguageOptions = () => {
  return WHISPER_LANGUAGES.map((lang) => ({
    value: lang.code,
    label: `${lang.flag} ${lang.name}`,
    searchLabel: lang.name.toLowerCase()
  }))
}

// South African official languages (for special grouping if needed)
export const SA_OFFICIAL_LANGUAGES = ['en', 'af', 'zu', 'xh', 'st', 'tn', 'nso', 've', 'ts', 'ss', 'nr']
